import { makeObservable, observable, computed, action } from 'mobx';
import dlzApi from '../api/LDApi';

class ConfigStore {
  config = null;

  constructor() {
    makeObservable(this, {
      config: observable,
      getConfig: action,
      isProd: computed,
    });
  }

  async getConfig() {
    if (this.config !== undefined) {
      return;
    }

    const { data } = await dlzApi.getConfig();
    this.config = data;
  }

  get isProd() {
    return this.config && this.config.env === 'production';
  }
}

export default new ConfigStore();
